import React from 'react'
import styles from "../../styles/components/duplicatesubmitvdoaccordion.module.scss"
import { Box, Button } from '@mui/material'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import sendProductIcon from '../../public/assets/images/sendProductIcon.svg'
import sendProductIconTwo from '../../public/assets/images/sendProductIcontwo.svg'

export const DuplicateSubmitVidAccordion = () => {
  return (
    <>
    <Box className={`${styles.vsidWrapperRed}`}>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Box className={styles.vsidWrapperHeading}>
                    <Typography variant='body1'>This video matches one or more previous submissions.</Typography>
                </Box>
            </AccordionSummary>

            <AccordionDetails>
                <Box className={styles.vsidRowBox}>
                    <Box className={styles.vsidRowBoxTxt}>
                        <p>Submission doesn’t match</p>
                        <Button className={styles.redVSIDbtn}>VSID 15645 <img src={sendProductIconTwo} width={14} height={14} alt='' /></Button>
                    </Box>

                </Box>

                <Box className={styles.vsidRowBox}>
                    <Box className={styles.vsidRowBoxTxt}>
                        <p>Submission matches</p>
                        <Button className={styles.redVSIDbtn}>VSID 15645 <img src={sendProductIcon} width={14} height={14} alt='' /></Button>
                    </Box>

                </Box>

                <Box className={styles.vsidRowBox}>
                    <Box className={styles.vsidRowBoxTxt}>
                        <p>Submission doesn’t match</p>
                        <Button className={styles.redVSIDbtn}>VSID 15645 <img src={sendProductIconTwo} width={14} height={14} alt='' /></Button>
                    </Box>

                </Box>
            </AccordionDetails>
        </Accordion>
    </Box>

</>
  )
}
